import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface Props {
  title: string;
  relativeTime: string;
}

export const NotificationTitleBar: FC<Props> = ({ title, relativeTime }) => {
  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Typography
        sx={{
          ...nawyTheme.nawy.typography.english.variants.body.md.semibold,
          color: nawyTheme.nawy.colors.semantic.text.primary,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          ...nawyTheme.nawy.typography.english.variants.body.xxs.regular,
          color: nawyTheme.nawy.colors.semantic.text.tertiary,
        }}
      >
        {relativeTime}
      </Typography>
    </Box>
  );
};
